// IconWithBadge.tsx
import React from "react";
import "./IconWithBadge.css";

interface IconWithBadgeProps {
  icon: JSX.Element;
  count: number;
  maxCount?: number;
  badgeColor?: string;
  position?: "top-right" | "top-left" | "bottom-right" | "bottom-left";
  title?: string;
}

const IconWithBadge: React.FC<IconWithBadgeProps> = ({
  icon,
  count,
  maxCount = 9,
  badgeColor = "var(--color-primary)",
  position = "top-right",
  title,
}) => {
  const displayCount = count > maxCount ? `${maxCount}+` : count;

  return (
    <div className="icon-badge-wrapper" title={title}>
      {icon}
      {count > 0 && (
        <span
          className={`icon-badge ${position}`}
          style={{ backgroundColor: badgeColor }}
        >
          {displayCount}
        </span>
      )}
    </div>
  );
};

export default IconWithBadge;
